export default {
  mounted(el) {
    const handleInput = (event) => {
      let trn = event.target.value.replace(/\D/g, '').substring(0, 9);
      event.target.value = trn.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');
    };

    el.addEventListener('input', handleInput);
    el._handleInput = handleInput;
  },
  beforeUnmount(el) {
    el.removeEventListener('input', el._handleInput);
    delete el._handleInput;
  }
}